package com.example.mystybag.appCore.model

data class LanguageSelectionBottomSheetUIState(
    val currentLanguageCode: String = ""
)
